import React from 'react';
import withStyles from '@mui/styles/withStyles'; 

const styles = theme => ({
    nextStepDiv:{
        width:'70%',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        borderRadius:'8px',
        display:'flex',
        flexDirection:'column',
        justifyContent:'space-around',
        padding: '10px 10px',
        marginTop:'10px',
        alignSelf:'center',
        alignItems:'flex-start',
        border: '1px solid #e4e8ed',
        backgroundColor:'#fff',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 20px)'
        },
        '& span':{
            fontFamily:'inherit',
            marginTop:'20px',
            wordBreak:'break-all',
            whiteSpace:'break-spaces'
        }
    },

    listCountSpan:{
        fontWeight: 'bold',
        fontSize: '12px',
        color:'#0F467A',
        marginTop:'10px',
        textTransform:'capitalize',
    }
});

class NextStepMessage extends React.Component {
    render() {
        const  { classes, groupNextStep } = this.props;
    return(
        <div className={classes.nextStepDiv}>
            <span className={classes.listCountSpan} style={{fontSize:'17px'}}>Next Step</span>
            <span style={{fontFamily:'inherit'}}>{groupNextStep}</span>
        </div>
    )}
}

export default withStyles(styles)(NextStepMessage);